import { PortalSession } from "./portal.types";

// The client portal has its own sign-in, separate from the firm's (Azure B2C).
const SESSION_KEY = "procharted-portal-session";
const FIRM_KEY = "procharted-portal-firm";
const EMAIL_KEY = "procharted-portal-email";

const read = (key: string): string | null => {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
};

const write = (key: string, value: string | null) => {
  try {
    if (value === null) window.localStorage.removeItem(key);
    else window.localStorage.setItem(key, value);
  } catch {
    // storage blocked (private mode): the session lasts until the page closes
  }
};

let memorySession: PortalSession | null = null;

export const getPortalSession = (): PortalSession | null => {
  const raw = read(SESSION_KEY);
  const session = raw ? (JSON.parse(raw) as PortalSession) : memorySession;
  if (!session || new Date(session.expiresAt).getTime() <= Date.now())
    return null;
  return session;
};

export const setPortalSession = (session: PortalSession | null) => {
  memorySession = session;
  write(SESSION_KEY, session ? JSON.stringify(session) : null);
};

/** The firm name and email from the last visit, shown on the sign-in page. */
export const getRememberedFirm = () => read(FIRM_KEY);
export const rememberFirm = (name: string) => write(FIRM_KEY, name);
export const getRememberedEmail = () => read(EMAIL_KEY) ?? "";
export const rememberEmail = (email: string) => write(EMAIL_KEY, email);
